module.exports = __webpack_public_path__ + "chevron-right.png?0070bb42b28434dcfb177b555a6f3c3a";